/**
 * Bonus-config save notifications.
 *
 * The config itself is SERVER ONLY (PUT /group/:id/bonus-config) — there is
 * no localStorage copy. This module only carries the same-tab event that
 * tells already-mounted surfaces (a dashboard sitting open behind the Team
 * Room tab) to refetch right after a save, instead of holding the ladder they
 * loaded at mount.
 */
export const BONUS_CONFIG_SAVED_EVENT = "gmb:bonus-config-saved";

/** Tell every mounted surface in THIS tab that the ladder changed. */
export const announceBonusConfigSaved = (workspaceId) => {
  try {
    window.dispatchEvent(new CustomEvent(BONUS_CONFIG_SAVED_EVENT, { detail: { workspaceId } }));
  } catch (e) {
    /* no CustomEvent (very old browser) — mount-time fetch still applies */
  }
};
